const PowerSchoolAquisition = () => {
  const launchDate = new Date('2022-06-07T09:30:00.000-07:00')
  const shouldDisplay = launchDate < new Date()

  if (shouldDisplay) {
    return (
      <div className="container" style={{ padding: '25px 0' }}>
        <div className="col-sm-5">
          <img
            src="/images/www/new/powerschool/halo-hero-web.png"
            className="img-responsive"
            alt="halo hero"
          />
        </div>
        <div className="col-sm-7 text-center">
          <img
            className="img-responsive"
            src="/images/www/new/powerschool/halo-logo-lockup-color-horizontal.png"
            alt="PowerSchool and Headed2"
          />
          <p style={{ fontSize: '1rem' }}>
            PowerSchool, the leading provider of cloud-based software for K-12 education
            in North America, completes acquisition of Headed2.
          </p>
          <a
            className="btn btn-primary btn-lg"
            style={{
              backgroundColor: '#2BAADF',
              border: '1px solid #2BAADF',
              marginTop: '25px'
            }}
            href="https://www.powerschool.com/headed2">
            Learn more about PowerSchool + Headed2
          </a>
        </div>
      </div>
    )
  }

  return null
}

export { PowerSchoolAquisition }
